import { CalloutBlock } from "@bezoned/shared/components/callout-block.jsx";
import { asStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";

export const RetryOrganizationCreation = ({
  onRetry,
}: {
  onRetry: () => void;
}) => (
  <div className="flex min-h-screen items-center justify-center bg-gray-100">
    <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
      <h1 className="mb-4 text-2xl font-bold text-gray-900">
        Organization Creation Failed
      </h1>

      <CalloutBlock variant="error">
        <p>
          We could not setup BeZoned for your organization. You may try again,
          or contact our support to get assistance.
        </p>
      </CalloutBlock>

      <button
        className="bg-bzd-button hover:bg-bzd-button-hover mt-4 w-full rounded-md px-4 py-2 text-white transition-colors"
        onClick={asStableCallback(() => onRetry())}
        type="button"
      >
        Retry
      </button>
    </div>
  </div>
);
